// removed by extract-text-webpack-plugin
module.exports = {"root":"_2BxN9","fadeOutIn":"_2VyxB"};